/**
 * Asks once about usage analytics (production builds only), docked at the bottom of the window above everything —
 * only where the regional default is "ask" (core logic/analyticsConsent) and the person hasn't chosen yet.
 */
import { AnalyticsConsent, useT } from "@bundle/ui";
import { useSyncExternalStore } from "react";
import { featureFlags } from "../platform/features.ts";
import { usePlatform } from "./PlatformContext.ts";

export function ConsentPrompt() {
  const t = useT();
  const { analytics } = usePlatform();
  const status = useSyncExternalStore(analytics.subscribe, analytics.getSnapshot, analytics.getSnapshot);
  if (!analytics.available || !status.prompt) return null;
  return (
    <div className="consent-dock" role="region" aria-label={t("consent.analytics.title")}>
      <AnalyticsConsent
        onAccept={() => analytics.setConsent(true)}
        onDecline={() => analytics.setConsent(false)}
        changeLaterIn={featureFlags.settings ? "settings" : "profileMenu"}
      />
    </div>
  );
}
